import { useState } from "react";
import { uploadImage } from "../../lib/api";
import { Upload, Loader2, X } from "lucide-react";

export default function ImageUploadField({ value, onChange }) {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setError(""); setUploading(true);
    try {
      const res = await uploadImage(file);
      onChange(res.url);
    } catch (err) {
      setError(err?.response?.data?.detail || "Upload failed");
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  return (
    <div>
      <div className="flex items-start gap-3">
        {value ? (
          <div className="relative shrink-0">
            <img
              src={value.startsWith("http") ? value : `${process.env.REACT_APP_BACKEND_URL}${value}`}
              alt="cover"
              className="w-32 h-20 object-cover rounded-lg border border-black/10"
              data-testid="image-preview"
            />
            <button
              type="button"
              onClick={() => onChange("")}
              className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-red-500 text-white grid place-items-center"
              data-testid="image-clear"
            >
              <X className="w-3 h-3" />
            </button>
          </div>
        ) : null}

        <label className="flex-1 cursor-pointer flex items-center justify-center gap-2 px-4 py-3 border-2 border-dashed border-black/10 rounded-lg hover:border-forest hover:bg-forest/5 transition" data-testid="image-upload-label">
          {uploading ? (
            <><Loader2 className="w-4 h-4 animate-spin" /> Uploading...</>
          ) : (
            <><Upload className="w-4 h-4" /> {value ? "Replace image" : "Upload image"}</>
          )}
          <input
            type="file"
            accept="image/jpeg,image/png,image/webp,image/gif"
            className="hidden"
            onChange={handle}
            disabled={uploading}
            data-testid="image-upload-input"
          />
        </label>
      </div>

      <div className="flex items-center gap-2 mt-2">
        <input
          type="text"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Or paste an image URL"
          className="w-full p-2 text-sm rounded-lg border border-black/10 focus:border-forest outline-none"
          data-testid="image-url-input"
        />
      </div>
      {error && <p className="text-red-600 text-xs mt-1">{error}</p>}
    </div>
  );
}
